<template>
  <ion-content>
    <section class="section bg-gradient-animated novi-background">
      <div class="container">
        <section class="section  novi-background pt-3 ">
          <div class="container">
            <!-- Breadcrumb-->
            <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link class="breadcrumb-link" to="/"><h5>My Account</h5></router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link class="breadcrumb-link breadcrumb-active" to="/opportunities/"><h5>Opportunities</h5></router-link>
              </li>
            </ul>
          </div>
        </section>

        <program-list :results="qualifiedPrograms"
                      :selected-program="preferredProgram"
                      :is-qualified="true"
                      :has-qualified-results="qualifiedPrograms.length > 0"
                      @program="selectProgram($event)"></program-list>

        <article v-if="preferredProgram" class="article-box-small blurb blurb-boxed blurb-light p-4 pb-0">
          <div class="blurb-title h6 text-center">Thank you for selecting your preferred Program</div>
          <div class="blurb-subtitle h6 text-center mb-1">Please add your education and english language qualifications</div>

          <div class="text-center border-1" >
            <router-link to="/education/" class="btn btn-lg btn-round text-center">
              <!--          <a class="btn btn-lg btn-round text-center" href="enrol/index.html">-->
              <span class="btn-icon mdi-file-pdf novi-icon"></span><span>EDUCATION QUALIFICATIONS</span>
              <!--            </a>-->
            </router-link>
          </div>

        </article>

        <program-list :results="possiblePrograms"
                      :selected-program="preferredProgram"
                      :is-qualified="false"
                      :has-qualified-results="qualifiedPrograms.length > 0"
                      @program="selectProgram($event)"></program-list>

<!--        <section class="section section-sm">-->
<!--          <div class="alert alert-info">-->
<!--            <div class="alert-inner">-->
<!--              <div class="alert-inner-item">-->
<!--                <h5 class="alert-title"><span class="icon alert-icon novi-icon int-info"></span>Select Your University and Program-->
<!--                </h5>-->
<!--                <div class="alert-text">Please provide your detailed education qualifications and select the preferred university</div>-->
<!--              </div>-->
<!--              <div class="alert-inner-item">-->
<!--                <div class="alert-inner-controls">-->
<!--                  <router-link class="btn btn-info" to="/program-select">Select</router-link>-->
<!--                  &lt;!&ndash;              <button class="link link-info">Dismiss</button>&ndash;&gt;-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </section>-->
        <section v-if="qualifiedPrograms.length === 0 && possiblePrograms.length === 0 "
                 class="section section-lg bg-transparent novi-background"
                 data-preset='{"title":"Blurb Sample","category":"blurb","reload":false,"id":"blurb-sample-5"}'>
          <div class="container">
            <h4 class="text-center">Our evaluation rules do not produce matching programs for your details. Our expert
              team
              can help you to find other options. We may also can advice you on how to get your qualifications improved to
              suite the available Visa programs.</h4>
            <h4 class="text-center">Please use the <a class="link link-success" href="contact-us.html">Contact Us</a> form
              to submit your details. one of our qualified member of staff will contact you as soon as possible.</h4>
          </div>
        </section>
      </div>
    </section>
  </ion-content>
</template>

<script>
import EoppService from "@/mixins/EoppService";
import ProgramList from "@/components/ProgramList";

export default {
  name: "Opportunities",
  mixins: [EoppService],
  components: {
    ProgramList
  },
  data() {
    return {
      status: null,
      toUpdate: null
    }
  },
  methods: {
    selectProgram: function (prog) {
      if (this.lead) {
        if (this.lead.cf.pref_program !== prog.code) {
          // this.lead.cf.pref_program = prog.code;
          this.$store.commit('pref_program', prog.code);
          // this.selectedProgram = prog;
          console.log(this.lead.cf.pref_program);
          this.updateCrmRecord([this.lead], null).then(res => {
            this.status = 'SUCCESS';
            console.log(res);
            setTimeout(() => {
              this.status = null;
            }, 2000);
          });
        }
      }
    }
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
